export enum ActionType {
  ADD = 'add',
  ADD_PAYMENT = 'add_payment',
  APPLY = 'apply',
  CLICK = 'click',
  CLOSE = 'close',
  COMPLETE = 'complete',
  CREATE = 'create',
  DISPLAY = 'display',
  ERROR = 'error',
  EXIT_FIELD = 'exit_field',
  LOCATION_CLICK = 'location_click',
  LOGIN = 'login',
  LOGOUT = 'logout',
  NEXT = 'next',
  OPEN = 'open',
  PREVIOUS = 'previous',
  PURCHASE = 'purchase',
  SELECT = 'select',
  SHOW = 'show',
  START = 'start',
  SUBMIT = 'submit',
  UPDATE = 'update',
  VIEW = 'view',
}
